const getPlatformClass = () => {
    const useragent = navigator.userAgent.toLowerCase();
    const isMac = useragent.includes('mac');
    const isWindows = useragent.includes('win');
    const isChrome = useragent.includes('chrome');
    const isFF = useragent.includes('firefox');
    if (isWindows && isChrome)
        return 'win-chrome';
    if (isWindows && isFF)
        return 'win-ff';
    if (isMac && isFF)
        return 'mac-ff';
    return 'unknown';
};
// RTL value can be overridden by web component's 'rtl' @property for compatibility with Storybook
// The html root "dir" attribute is used for the Episerver and "rtl" attribute should not be used in Razor views
const isRTL = () => document.querySelector('html').getAttribute('dir') === 'rtl';
const getLang = () => document.querySelector('html').getAttribute('lang');
const isSafari = /Version\/[\d.]+.*Safari/.test(window.navigator.userAgent);
const isLink = (element, contextToCheck = null) => {
    var _a;
    const parentLinkElement = element === null || element === void 0 ? void 0 : element.closest('a');
    const childAnchor = (_a = element === null || element === void 0 ? void 0 : element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a');
    return (element instanceof HTMLAnchorElement ||
        parentLinkElement ||
        (childAnchor && childAnchor instanceof HTMLAnchorElement) ||
        (contextToCheck &&
            contextToCheck.forEach((context) => (element === null || element === void 0 ? void 0 : element.parentNode) instanceof context)));
};
const getLinkURL = (element) => {
    var _a;
    const parent = element === null || element === void 0 ? void 0 : element.closest('a');
    const childAnchor = (_a = element === null || element === void 0 ? void 0 : element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a');
    let url = '';
    if (element instanceof HTMLAnchorElement) {
        url = element.href;
    }
    else if (parent) {
        url = parent.href;
    }
    else if (childAnchor && childAnchor instanceof HTMLAnchorElement) {
        url = childAnchor.href;
    }
    return url;
};
function observeDOM(obj, callback) {
    const { MutationObserver } = window;
    if (!obj || obj.nodeType !== 1)
        return;
    const mutationObserver = new MutationObserver(callback);
    mutationObserver.observe(obj, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'className'],
    });
    // eslint-disable-next-line consistent-return
    return mutationObserver;
}
const getSlotContentByName = (element, slotName) => {
    var _a;
    const slot = (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`slot[name="${slotName}"]`);
    if (!slot) {
        console.warn(`Could not find text content in slot[name="${slotName}"] or parent element/slot does not exist`);
        return null;
    }
    return slot === null || slot === void 0 ? void 0 : slot.assignedElements()[0];
};
const setDataAttributes = (ctx, headingSlotName, textSlotName) => {
    if (headingSlotName !== null)
        ctx.headingSlot = getSlotContentByName(ctx, headingSlotName);
    if (ctx.headingSlot)
        ctx.headingSlot.dataset.text = ctx.headingSlot.innerHTML;
    if (textSlotName !== null)
        ctx.textSlot = getSlotContentByName(ctx, textSlotName);
    if (ctx.textSlot)
        ctx.textSlot.dataset.text = ctx.textSlot.innerHTML;
};
const getContainerClass = (isIcon, size) => {
    if (isIcon) {
        return size === 'Small' ? 'small-icon-container' : 'large-icon-container';
    }
    return size === 'Small' ? 'small-image-container' : 'large-image-container';
};

export { getContainerClass, getLang, getLinkURL, getPlatformClass, getSlotContentByName, isLink, isRTL, isSafari, observeDOM, setDataAttributes };
